import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListVoucherComponent } from './list-voucher.component';
import { SvgIconModule } from '../svg-icon';



@NgModule({
    declarations: [ListVoucherComponent],
    imports: [
        CommonModule,
        SvgIconModule
    ],
    exports: [
        ListVoucherComponent
    ]
})
export class ListVoucherModule { }
